import * as React from 'react'

import { Icon } from '@factorialco/deprecated-design-system'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import i18n from 'modules/core/lib/i18n'
import { matchText } from 'modules/core/lib/stringUtils'

import type { ResultType } from 'modules/command_bar/lib/types'
import getTitle from 'modules/documents/components/Documents/getTitle'
import type { Folders } from 'modules/documents/store/collections/folders'

export interface FolderResults {
  search: string
  foldersCollection: Folders
}

export const useFolderResults = ({ search, foldersCollection }: FolderResults): ResultType[] => {
  const { navigation } = useNavigation()

  if (!search.length) return []

  return foldersCollection
    .filter((folder) => folder.attributes.is_employee && matchText(search, folder.attributes.name))
    .map(
      (folder): ResultType => ({
        id: folder.id,
        text: `${i18n.t('command_bar.plugins.documents.categories.my_documents')} -> ${getTitle(
          folder?.attributes.name
        )}`,
        IconComponent: () => <Icon.Medium icon="folder" />,
        type: 'navigation',
        score: 2,
        navigationPath: navigation.documents.folderId.fullPath({
          folderId: folder.attributes.id,
        }),
      })
    )
}
